export const PRODUCT_ADD = "PRODUCT_ADD";
export const GET_TOTAL_ITEM = "GET_TOTAL_ITEM ";
export const PRODUCT_DECREMENT = "PRODUCT_DECREMENT ";
